import { createFileRoute } from '@tanstack/react-router'
import { requireAdmin } from '@/lib/auth-guards'
import { qrCodesSearchSchema } from '@/features/qr-codes/data/schema'
import { QrCodesPage } from '@/features/qr-codes/qr-codes-page'

export const Route = createFileRoute('/_authenticated/qr-codes/')({
  beforeLoad: requireAdmin,
  validateSearch: qrCodesSearchSchema,
  component: QrCodesPage,
})
